import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

import { ListPageLayout } from '@/components/templates';
import { Button } from '@/components/atoms/button';
import { PickupConfirmation } from '@/features/orders/components/PickupConfirmation';

export default function OrderPickupsPage() {
  const { t } = useTranslation();

  return (
    <ListPageLayout
      title={t('orders.pickupConfirmation.title')}
      description={t('orders.pickupConfirmation.subtitle')}
      actions={
        <Button variant="outline" asChild>
          <Link to="/orders">
            <ArrowLeft />
            {t('orders.pickupConfirmation.back')}
          </Link>
        </Button>
      }
    >
      <PickupConfirmation />
    </ListPageLayout>
  );
}
